import { Component, Input, EventEmitter, Output, OnInit, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { RegiaoSearch } from '../regiao-search';
import { RegiaoFilter } from '../filter';
import { RegiaoCrudHttpService } from '../services';
import { regiaoSituacaoAtiva } from '../situacao';

@Component({
    selector: 'sgt-regiao-select',
    templateUrl: './regiao-select.component.html',
    styleUrls: ['./regiao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RegiaoSelectComponent), multi: true },
    ]
})
export class RegiaoSelectComponent implements OnInit, OnChanges {
    /** ID da região selecionada */
    @Input() ngModel: number;
    /** Ao alterar a região selecionada */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Região */
    @Input() regiao: RegiaoSearch;
    @Output() regiaoChange = new EventEmitter<RegiaoSearch>();

    /** Se deve filtrar somente as regiões ativas */
    @Input() somenteAtivas = false;
    /** Se é obrigatório informar o representante no filtro para pesquisar */
    @Input() representanteFilterRequired = false;
    /** ID do representante para filtar as regiões */
    @Input() idRepresentanteFilter: number = null;
    /** Se é obrigatório informar o estado no filtro para pesquisar */
    @Input() estadoFilterRequired = false;
    /** ID do estado para filtrar as regiões */
    @Input() idEstadoFilter: number = null;

    /**
     * Nome do select
     */
     @Input() name: string;
    /**
     * ID do select
     */
    @Input() id: string;
    /**
     * Se a região é obrigatória
     */
     @Input() required: any;
    /**
     * Se deve desabilitar o select
     */
     @Input() disabled: any;

    regioes: RegiaoSearch[] = [];

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private regiaoCrudHttpService: RegiaoCrudHttpService) { }

    ngOnInit() {
        this.search();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'idRepresentanteFilter') {
                if (!changes[propName].isFirstChange()) {
                    this.search();
                }
            }
        };
    }

    /** Pesquisa as regiões */
    private search() {
        this.regioes = [];

        // Filtro do representante obrigatório
        if (this.representanteFilterRequired && !this.idRepresentanteFilter) {
            return;
        }
        // Filtro do estado obrigatório
        if (this.estadoFilterRequired && !this.idEstadoFilter) {
            return;
        }

        const filter = new RegiaoFilter();
        // Somente ativas
        if (this.somenteAtivas) {
            filter.situacoes = [regiaoSituacaoAtiva.id];
        }
        // Representante
        if (this.idRepresentanteFilter) {
            filter.idRepresentante = this.idRepresentanteFilter;
        }
        // Estado
        if (this.idEstadoFilter) {
            filter.idEstado = this.idEstadoFilter;
        }

        this.regiaoCrudHttpService.searchWithFilter(filter, 0, null, null, 3, 'asc')
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    this.regioes = response?.data ?? [];

                    if (this.regiao) {
                        const indexRecurso = this.regioes?.findIndex(recursoFilter => recursoFilter.id === this.regiao.id);
                        if (indexRecurso < 0) {
                            this.regioes.unshift(this.regiao);
                        }
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as regiões para selecionar', error)
            );
    }

    /** Ao alterar a região */
    onChange(idRegiao: number) {
        this.ngModel = idRegiao;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.regiao = this.regioes?.find(recursoFilter => recursoFilter.id === idRegiao);
        this.regiaoChange.emit(this.regiao);
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
